module.exports = __webpack_public_path__ + "static/media/icon-modal-close.850e530c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FeedModal/icon-modal-close.svg
// module id = 509
// module chunks = 1